const XOF_COUNTRIES = new Set([
  'BJ', 'BF', 'CI', 'GW', 'ML', 'NE', 'SN', 'TG',
]);

const EUR_COUNTRIES = new Set([
  'AT', 'BE', 'CY', 'DE', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'IE', 'IT',
  'LT', 'LU', 'LV', 'MT', 'NL', 'PT', 'SI', 'SK',
]);

const SPANISH_COUNTRIES = new Set([
  'ES', 'MX', 'AR', 'CO', 'CL', 'PE', 'VE', 'EC', 'GT', 'CU', 'BO', 'DO',
  'HN', 'PY', 'SV', 'NI', 'CR', 'PA', 'UY',
]);

const RUSSIAN_COUNTRIES = new Set(['RU', 'BY', 'KZ', 'KG']);

const FRENCH_COUNTRIES = new Set([
  'FR', 'BE', 'CH', 'LU', 'MC', 'CD', 'CG', 'GA', 'CM', 'MG', 'MU',
  'BJ', 'BF', 'CI', 'GW', 'ML', 'NE', 'SN', 'TG',
]);

const PHONE_PREFIX_COUNTRY = [
  ['509', 'HT'],
  ['221', 'SN'],
  ['225', 'CI'],
  ['223', 'ML'],
  ['226', 'BF'],
  ['228', 'TG'],
  ['229', 'BJ'],
  ['245', 'GW'],
  ['44', 'GB'],
  ['86', 'CN'],
  ['852', 'HK'],
  ['886', 'TW'],
  ['55', 'BR'],
  ['33', 'FR'],
  ['34', 'ES'],
  ['7', 'RU'],
  ['1', 'US'],
];

export const normalizeCountryCode = (raw) => {
  const code = String(raw || '').trim().toUpperCase();
  if (code.length === 2 && code !== 'XX' && code !== 'T1') return code;
  return null;
};

export const detectCountryFromPhone = (phone) => {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return null;
  const sorted = [...PHONE_PREFIX_COUNTRY].sort((a, b) => b[0].length - a[0].length);
  for (const [prefix, country] of sorted) {
    if (digits.startsWith(prefix)) return country;
  }
  return null;
};

export const resolveVisitorCountry = ({ countryCode, phone } = {}) => {
  const fromHeader = normalizeCountryCode(countryCode);
  if (fromHeader) return fromHeader;
  return detectCountryFromPhone(phone);
};

export const detectCurrencyFromCountry = (countryCode) => {
  const code = normalizeCountryCode(countryCode);
  if (!code) return null;
  if (code === 'HT') return 'HTG';
  if (XOF_COUNTRIES.has(code)) return 'XOF';
  if (code === 'BR') return 'BRL';
  if (code === 'CN' || code === 'HK' || code === 'TW') return 'CNY';
  if (code === 'GB') return 'GBP';
  if (EUR_COUNTRIES.has(code)) return 'EUR';
  return 'USD';
};

export const detectLanguageFromCountry = (countryCode) => {
  const code = normalizeCountryCode(countryCode);
  if (!code) return null;
  if (code === 'HT') return 'ht';
  if (SPANISH_COUNTRIES.has(code)) return 'es';
  if (RUSSIAN_COUNTRIES.has(code)) return 'ru';
  if (FRENCH_COUNTRIES.has(code)) return 'fr';
  return 'en';
};

/**
 * Fetch visitor ISO country from the same-origin Vercel /api/geo endpoint so we
 * get x-vercel-ip-country. Direct calls to api.kayicom.com miss that header.
 */
export const fetchVisitorCountry = async () => {
  if (typeof window === 'undefined') return null;
  const host = window.location.hostname || '';
  const isLocal = host === 'localhost' || host === '127.0.0.1' || host === '[::1]';

  try {
    if (!isLocal) {
      const res = await fetch('/api/geo', { cache: 'no-store' });
      if (res.ok) {
        const data = await res.json();
        const code = normalizeCountryCode(data?.country);
        if (code) return code;
      }
    }
  } catch {
    // ignore
  }

  try {
    const backend = String(process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');
    if (backend) {
      const res = await fetch(`${backend}/api/geo`, { cache: 'no-store' });
      if (res.ok) {
        const data = await res.json();
        return normalizeCountryCode(data?.country);
      }
    }
  } catch {
    // ignore
  }

  return null;
};
